import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, FormGroup,
         Label, Input, Col } from 'reactstrap';
import validator from 'validator';
import { NavLink } from 'react-router-dom';
import { getPaymentRedirectHtmlForm,
         stopStatusSimpleCheking} from '../../actions/creditCardActions';
import { connect } from 'react-redux';
import IndicatorLoading from './../indicatorLoading/IndicatorLoading';
import Alert from './../Alert/Alert';
import { hideAlert } from './../../actions/AlertActions';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import T from 'i18n-react';

const requireAmmount = 'Amount is required';
const numberAmmount = 'Amount must be a number';

class CreditCardSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: '10',
      amountError:'',
      htmlFormSimple: '',
      showSimpleHtmlForm: false,
      visible: false
    };
  }

  componentWillMount(){
  }

  onAmountChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({amount: val});
    //validation required
    if (!val)
      this.setState({amountError: requireAmmount});
    else if ( !validator.isNumeric(val) ){
      this.setState({amountError: numberAmmount});
    }else
      this.setState({amountError: ''});
  }

  onPayCreditCardClick = (e) => {
    console.log('onPayCreditCardClick');
    if (!this.validationFields())
      return;
    stopStatusSimpleCheking();
    this.props.hideAlert();
    this.props.getPaymentRedirectHtmlForm(
                      this.props.accountId,
                      this.state.amount,
                      "EUR"
                    );
  }

  onBackClick = () => {
    console.log('back click');
    const { router } = this.context;
    stopStatusSimpleCheking();
    router.history.push('/topUpEwallet');
  }

  validationFields(){
    let valid = true;
    return valid;
  }

  componentWillReceiveProps(nextProps){
    console.log(nextProps);
    let accountId = localStorage.getItem('accountId');
    if (nextProps.htmlFormSimple != ""){
      this.setState({showSimpleHtmlForm: true});
    }else if (nextProps.htmlFormSimple == ""){
      this.setState({showSimpleHtmlForm: false});
    }
  }

  iframeLoaded(e){
    console.log('iframe loaded');
  }

  render() {

    const {visible, typeMessage, textMessage, showIndicator
    } = this.props;

    const message = {
        type: typeMessage,
        text: textMessage
    }

      return(
        <div className="">
        <div className="col-sm-10 col-md-8">
          <h4 className="title-screen">
            <T.text tag='span' text="with_credit_card"/>
          </h4>
          <div className="form-group row" id="amountFld">
              <label className="col-sm-2 amount">
                <T.text tag='span' text="amount_fld"/>
              </label>
              <div className="col-sm-8">
                  <select className="form-control inp-select" onChange={this.onAmountChange}>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                  </select>
              </div>
          </div>

          <div className="row">
          <div className="col-sm-12">
            <a href="http://www.parkpal.gr/terms/">
              <T.text tag='span' text="terms_and_conditions"/>
            </a>
          </div>
        </div>

        </div>
        { showIndicator &&
          <IndicatorLoading/>
        }
        { this.state.showSimpleHtmlForm && !showIndicator &&
          <div className="col-sm-12 col-md-12" id="paymentWrap">
            <iframe srcDoc={this.props.htmlFormSimple}
              id="paymentFrm"
               onLoad={this.iframeLoaded}
              width="100%" height="100%" scrolling='auto' >
            </iframe>
          </div>
        }

        <div className="col-md-6 col-sm-8">
        <ReactCSSTransitionGroup
            transitionName="appear"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>
         { visible == true  &&
             <Alert  message={message} />
         }
        </ReactCSSTransitionGroup>
        </div>

        <div className="col-sm-10 col-md-8">
        <FormGroup row id="bottomCntCredit">
          <div className="col-md-6">
             <Button color="warning" className="back-btn"
               onClick={() => this.onBackClick()}>
                 <T.text tag='span' text="back"/>
               </Button>
          </div>

          <div className="col-md-6">
             <Button color="warning" className="settings-btn"
               onClick={() => this.onPayCreditCardClick()}>
                 <T.text tag='span' text="make_payment_but"/>
             </Button>
          </div>
        </FormGroup>
      </div>
    </div>
    )
  }
}

//export default CreditCardSimple;

CreditCardSimple.contextTypes = {
  router: React.PropTypes.object
}

export default connect(
  (state)=>{
    console.log("state ", state)
    return {
      accountId: state.authReducer.accountId,
      htmlFormSimple: state.creditCard.htmlFormSimple,
      visible: state.alert.visible,
      typeMessage: state.alert.type,
      textMessage: state.alert.message,
      showIndicator: state.authReducer.showIndicator
      //ammount: state.authReducer.licensePlate
    }
  },
  { getPaymentRedirectHtmlForm, hideAlert }
)(CreditCardSimple);



// WEBPACK FOOTER //
// ./src/components/creditCardSimple/CreditCardSimple.js